import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Button } from '@resy/ui-kitchen';
import PlusIcon from '../../../../../../ui-kitchen/src/svg/icons/ic_add_20x20.svg';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';
import { handleMktAnalytics } from '../../AmexMarketingUtils/AmexUtils';
import { CTA_EVENT_NAME } from '../../AmexMarketingUtils/constants';
import './ResyRewardsFAQs.scss';

const getQuestionId = (index) => `resyRewardsFaq${index}`;

const ResyRewardsFAQs = ({ eventAnalytics, faqsConfig }) => {
  const {
    title,
    section_id: sectionId,
    subsections = [],
  } = faqsConfig || {};

  const faqs = subsections.filter((item) => item.question && item.answer);
  const [openIndex, setOpenIndex] = useState();

  if (!title || faqs.length === 0) return null;

  const onToggle = (index, question) => {
    setOpenIndex((current) => (current === index ? null : index));
    handleMktAnalytics(eventAnalytics, CTA_EVENT_NAME, {
      action_name: 'FAQ - Click',
      item_name: question,
    });
  };

  return (
    <section className="ResyRewardsFAQs" id={sectionId || undefined}>
      <div className="container">
        <h2
          className="ResyRewardsFAQs__title"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: sanitizeString(title) }}
        />
        <ul className="ResyRewardsFAQs__list">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            const questionId = getQuestionId(index);
            const answerId = `${questionId}Answer`;

            return (
              <li
                className={cx('ResyRewardsFAQs__item', { 'ResyRewardsFAQs__item--open': isOpen })}
                key={item.question}
              >
                <h3 className="ResyRewardsFAQs__question">
                  <Button
                    variant="no-style"
                    type="button"
                    id={questionId}
                    className="ResyRewardsFAQs__toggle"
                    aria-expanded={isOpen}
                    aria-controls={answerId}
                    onClick={() => onToggle(index, item.question)}
                  >
                    <span
                      className="ResyRewardsFAQs__question-text"
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{ __html: sanitizeString(item.question) }}
                    />
                    <span className="ResyRewardsFAQs__icon" aria-hidden="true">
                      <PlusIcon />
                    </span>
                  </Button>
                </h3>
                <div
                  role="region"
                  id={answerId}
                  aria-labelledby={questionId}
                  className="ResyRewardsFAQs__answer"
                  aria-hidden={!isOpen}
                >
                  <div className="ResyRewardsFAQs__answer-inner">
                    <div
                      className="ResyRewardsFAQs__answer-text"
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{ __html: sanitizeString(item.answer) }}
                    />
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

ResyRewardsFAQs.propTypes = {
  eventAnalytics: PropTypes.func,
  faqsConfig: PropTypes.shape({
    title: PropTypes.string,
    section_id: PropTypes.string,
    subsections: PropTypes.arrayOf(PropTypes.shape({
      question: PropTypes.string,
      answer: PropTypes.string,
    })),
  }),
};

ResyRewardsFAQs.defaultProps = {
  eventAnalytics: null,
  faqsConfig: null,
};

export default ResyRewardsFAQs;
